/* tslint:disable */
/* eslint-disable */
// Kézzel karbantartva a generált app-*-backend.service.ts minta szerint (Hibajelzés: api/app/issue-report/*).
// A csatolmány-feltöltés (multipart) és -letöltés (blob) az AppIssueReportService-ben van, mint a kampányképeknél.
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import {
  AdminIssueReportListRequest as BackendCoreApiModelsAppIssueReportAdminIssueReportListRequest,
  AdminIssueReportListResponse as BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse,
  CreateIssueReportRequest as BackendCoreApiModelsAppIssueReportCreateIssueReportRequest,
  CreateIssueReportResponse as BackendCoreApiModelsAppIssueReportCreateIssueReportResponse,
  GetIssueReportRequest as BackendCoreApiModelsAppIssueReportGetIssueReportRequest,
  IssueReportDto as BackendCoreApiModelsAppIssueReportIssueReportDto,
  IssueReportListRequest as BackendCoreApiModelsAppIssueReportIssueReportListRequest,
  IssueReportListResponse as BackendCoreApiModelsAppIssueReportIssueReportListResponse,
  SetIssueReportStateRequest as BackendCoreApiModelsAppIssueReportSetIssueReportStateRequest,
} from '../models/Backend/Core/Api/Models/App/IssueReport/issue-report-models';

@Injectable({
  providedIn: 'root',
})
export class AppIssueReportBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createIssueReport
   */
  static readonly CreateIssueReportPath = '/api/app/issue-report/create';

  /**
   * Új hibajelzés (patika).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIssueReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createIssueReport$Json$Response(params: {
    body: BackendCoreApiModelsAppIssueReportCreateIssueReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppIssueReportCreateIssueReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppIssueReportBackendService.CreateIssueReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppIssueReportCreateIssueReportResponse>;
      })
    );
  }

  /**
   * Új hibajelzés (patika).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createIssueReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createIssueReport$Json(params: {
    body: BackendCoreApiModelsAppIssueReportCreateIssueReportRequest
  }): Observable<BackendCoreApiModelsAppIssueReportCreateIssueReportResponse> {

    return this.createIssueReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppIssueReportCreateIssueReportResponse>) => r.body as BackendCoreApiModelsAppIssueReportCreateIssueReportResponse)
    );
  }

  /**
   * Path part for operation listIssueReports
   */
  static readonly ListIssueReportsPath = '/api/app/issue-report/list';

  /**
   * A saját patika hibajelzései.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listIssueReports$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  listIssueReports$Json$Response(params?: {
    body?: BackendCoreApiModelsAppIssueReportIssueReportListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppIssueReportBackendService.ListIssueReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportListResponse>;
      })
    );
  }

  /**
   * A saját patika hibajelzései.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listIssueReports$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  listIssueReports$Json(params?: {
    body?: BackendCoreApiModelsAppIssueReportIssueReportListRequest
  }): Observable<BackendCoreApiModelsAppIssueReportIssueReportListResponse> {

    return this.listIssueReports$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportListResponse>) => r.body as BackendCoreApiModelsAppIssueReportIssueReportListResponse)
    );
  }

  /**
   * Path part for operation getIssueReport
   */
  static readonly GetIssueReportPath = '/api/app/issue-report/get';

  /**
   * Egy hibajelzés részletei.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIssueReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getIssueReport$Json$Response(params: {
    body: BackendCoreApiModelsAppIssueReportGetIssueReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>> {

    const rb = new RequestBuilder(this.rootUrl, AppIssueReportBackendService.GetIssueReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>;
      })
    );
  }

  /**
   * Egy hibajelzés részletei.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIssueReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getIssueReport$Json(params: {
    body: BackendCoreApiModelsAppIssueReportGetIssueReportRequest
  }): Observable<BackendCoreApiModelsAppIssueReportIssueReportDto> {

    return this.getIssueReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>) => r.body as BackendCoreApiModelsAppIssueReportIssueReportDto)
    );
  }

  /**
   * Path part for operation adminListIssueReports
   */
  static readonly AdminListIssueReportsPath = '/api/app/issue-report/admin/list';

  /**
   * Minden patika hibajelzése szűrve, állapot-számlálókkal (admin).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminListIssueReports$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminListIssueReports$Json$Response(params?: {
    body?: BackendCoreApiModelsAppIssueReportAdminIssueReportListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppIssueReportBackendService.AdminListIssueReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse>;
      })
    );
  }

  /**
   * Minden patika hibajelzése szűrve, állapot-számlálókkal (admin).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `adminListIssueReports$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminListIssueReports$Json(params?: {
    body?: BackendCoreApiModelsAppIssueReportAdminIssueReportListRequest
  }): Observable<BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse> {

    return this.adminListIssueReports$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse>) => r.body as BackendCoreApiModelsAppIssueReportAdminIssueReportListResponse)
    );
  }

  /**
   * Path part for operation adminSetIssueReportState
   */
  static readonly AdminSetIssueReportStatePath = '/api/app/issue-report/admin/set-state';

  /**
   * Állapotváltás megjegyzéssel (admin); a patika portál-értesítést kap.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminSetIssueReportState$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminSetIssueReportState$Json$Response(params: {
    body: BackendCoreApiModelsAppIssueReportSetIssueReportStateRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>> {

    const rb = new RequestBuilder(this.rootUrl, AppIssueReportBackendService.AdminSetIssueReportStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>;
      })
    );
  }

  /**
   * Állapotváltás megjegyzéssel (admin); a patika portál-értesítést kap.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `adminSetIssueReportState$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  adminSetIssueReportState$Json(params: {
    body: BackendCoreApiModelsAppIssueReportSetIssueReportStateRequest
  }): Observable<BackendCoreApiModelsAppIssueReportIssueReportDto> {

    return this.adminSetIssueReportState$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppIssueReportIssueReportDto>) => r.body as BackendCoreApiModelsAppIssueReportIssueReportDto)
    );
  }

  /**
   * Path part for the attachment download (GET api/app/issue-report/attachment/{id}); a fájlt az
   * AppIssueReportService tölti le blobként, auth fejléccel.
   */
  static readonly AttachmentPath = '/api/app/issue-report/attachment';

  /**
   * Path part for the attachment upload (POST api/app/issue-report/attachment/upload, multipart: id, file).
   */
  static readonly UploadAttachmentPath = '/api/app/issue-report/attachment/upload';
}
